/**
 * Avalara © 2017
 * file: engines/opus_ui/src/actions/search.js
 */

import {
  queryClasses,
} from '../helpers/biztechQueries';

export const SEARCH_FIELD_UPDATED = 'SEARCH_FIELD_UPDATED';
export const FETCH_SEARCH_RESULTS_REQUEST = 'FETCH_SEARCH_RESULTS_REQUEST';
export const FETCH_SEARCH_RESULTS_SUCCESS = 'FETCH_SEARCH_RESULTS_SUCCESS';
export const FETCH_SEARCH_RESULTS_FAILURE = 'FETCH_SEARCH_RESULTS_FAILURE';
export const FETCH_CARD_RESULTS_SUCCESS = 'FETCH_CARD_RESULTS_SUCCESS';

//I don't this this function is used anywhere
export function updateSearch(queryString) {
  return { type: SEARCH_FIELD_UPDATED, payload: queryString };
}

export function fetchSearchResultsIfNeeded(queryString, caseUrlParam) {
  // One of our develepers who will remain nameless likes to have a bunch of tabs open in a tree view and likes to read the tab titles.
  document.title = `OPUS: ${queryString}`;
  return (dispatch, getState) => {
    if (shouldFetchSearchResults(getState().search, queryString)) {
      // let token = getState().auth.token;
      return fetchSearchResults(dispatch, queryString, caseUrlParam);
    }
  };
}

function shouldFetchSearchResults(reduxState, queryString) {
  if (!reduxState || reduxState.didInvalidate) {
    return true;
  }
  return !reduxState.isFetching && reduxState.queryString !== queryString;
}

function fetchSearchResults(dispatch, queryString, caseUrlParam) {
  if (queryString) {
    const searchSystems = Object.keys(queryClasses);
    dispatch(fetchSearchResultsRequest(searchSystems));
    searchSystems.forEach((key) =>
      queryClasses[key]
        .initialQuery(queryString)
        .then((res) =>
          dispatch(
            receiveSearchResults(res || {}, key, queryString, caseUrlParam)
          )
        )
        .catch((ex) => {
          return dispatch(searchResultsFailure(key, queryString));
        })
    );
  }
}

function fetchSearchResultsRequest(searchSystems) {
  return { type: FETCH_SEARCH_RESULTS_REQUEST, searchSystems };
}

function receiveSearchResults(data, source, queryString, caseUrlParam) {
  return {
    type: FETCH_SEARCH_RESULTS_SUCCESS,
    data,
    source,
    queryString,
    caseUrlParam,
  };
}

function searchResultsFailure(source, queryString) {
  return { type: FETCH_SEARCH_RESULTS_FAILURE, source, queryString };
}

//Is this cheating? Am I abusing the redux pattern?
export function finishedLoadingNewTopCard(dispatch, newCard) {
  dispatch({ type: FETCH_CARD_RESULTS_SUCCESS, newCard });
}

